module.exports = __webpack_public_path__ + "img/alex-morgan.64eb6292.png";